import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import ReactTooltip from 'react-tooltip'

import CommentCountIndicator from '../../mini/comments/CommentCountIndicator'
import DraftCommentIndicator from '../../mini/comments/DraftCommentIndicator'

import {
  hasActivityDraftComments,
  getActivityCommentCount
} from '../../../utils/questmenuitem'
import { activityHasContentWarnings } from '../../../utils/contentwarnings'
import { isActivityComplete } from '../../../utils/quest'

class Activity extends Component {
  constructor(props) {
    super(props)
    this.onClickBound = this.onClick.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // // Need this because of sorting activities; menu items won't be on DOM
    if (
      nextProps.activity.activity_order === this.props.activity.activity_order
    ) {
      // Ensures the current activity menu item is highlighted when that activity is being viewed
      const _el = document.getElementById(nextProps.activity.id)
      if (
        nextProps.questSection === 'activities' &&
        nextProps.activity.id === nextProps.activityId
      ) {
        _el.classList.add('active')
      } else {
        // Remove the highlighting if not actively viewed
        _el.classList.remove('active')
      }
    }
  }

  render() {
    const { activity, index, comments, draftActivityComments } = this.props
    const complete = isActivityComplete(activity)
    let commentCount

    if (comments) {
      commentCount = getActivityCommentCount(comments, activity)
    }

    return (
      <li
        key={index}
        id={activity.id}
        className={complete ? 'complete' : 'incomplete'}
        onClick={this.onClickBound}
      >
        <div className="label-container">
          <label>
            {index + 1}. {activity.name}
          </label>
          {activityHasContentWarnings(activity) && (
            <React.Fragment>
              <div
                className="generic-content-warning"
                data-for="genericContentWarning"
                data-tip="One or more resources have content warnings"
              />
              <ReactTooltip
                id="genericContentWarning"
                effect={'solid'}
                offset={{ top: -2 }}
              />
            </React.Fragment>
          )}
        </div>
        <div className="draft-comment-indicator-container">
          {draftActivityComments &&
            hasActivityDraftComments(draftActivityComments, activity) && (
              <DraftCommentIndicator />
            )}
        </div>
        <div className="comment-count-indicator-container">
          {commentCount > 0 && (
            <CommentCountIndicator commentCount={commentCount} />
          )}
        </div>
      </li>
    )
  }

  onClick() {
    const { activity, dispatch, questId } = this.props
    dispatch(push(`/quest/${questId}/activities/${activity.id}`))
  }
}

Activity.propTypes = {
  dispatch: PropTypes.func.isRequired,
  activity: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  comments: PropTypes.array,
  questSection: PropTypes.string,
  activityId: PropTypes.number,
  questId: PropTypes.number,
  draftActivityComments: PropTypes.array
}

export const mapStateToProps = state => ({
  comments: state.quest.activityComments,
  questSection: state.quest.section,
  activityId: state.quest.activityId,
  questId: state.quest.item.id,
  draftActivityComments: state.quest.userActivityComments
})

export default connect(mapStateToProps)(Activity)
export { Activity as ActivityDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/components/quest/menu/Activity.js